import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-2"><path d="M21.25 10.75V19.25H2.75V10.75M21.25 10.75H18.75M21.25 10.75V4.75H2.75V10.75M2.75 10.75H5.25M5.25 10.75H7.75L9.94444 12.25H14.0556L16.25 10.75H18.75M5.25 10.75V7.75C5.25 7.47386 5.47386 7.25 5.75 7.25H18.25C18.5261 7.25 18.75 7.47386 18.75 7.75V10.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWallet2;
